import { ListItemLabel } from "baseui/list";
import { SpecialEventCalendarEntryPeriod } from "../../../../services/schedulers/types";
import { date_isFixDate, flexDate_asDate } from "../../Calendar/utils";
import { FormattedDate } from "react-intl";

export const DateListItem = (props: { eventPriority: number, period: SpecialEventCalendarEntryPeriod }) => {
    const { eventPriority, period } = props;

    if (period.date !== undefined) {
        if (date_isFixDate(period.date))
            return (<ListItemLabel description={`Priority: ${eventPriority}`}>
                <FormattedDate day="numeric"
                    month="long"
                    year="numeric" value={flexDate_asDate(period.date)}></FormattedDate>
            </ListItemLabel>)
    }
    
    return (<ListItemLabel description={`Priority: ${eventPriority}`}>{JSON.stringify(period)}</ListItemLabel>)
}